import { detectIncognito as detectIncognitojs } from "detectincognitojs";

export const detectIncognito = () =>
  new Promise((resolve) => {
    detectIncognitojs()
      .then(resolve)
      .catch(() => resolve({ isPrivate: false }));
  });
